import {
  CheckCircle2,
  PlayCircle,
  FileQuestion,
  Award,
  Download,
} from "lucide-react";
import { Button } from "./button";
import { cn } from "./utils";

const ModuleProgress = ({
  videoProgress,
  quizCompleted,
  quizScore,
  passed,
  onDownloadCertificate,
}) => {
  const quizUnlocked = videoProgress >= 100;
  return (
    <div className="border rounded-xl p-6">
      <h3 className="font-semibold mb-4">Module Progress</h3>

      <div className="space-y-3 text-sm">
        <div className={cn(videoProgress >= 100 && "text-green-600")}>
          <PlayCircle /> Video: {Math.round(videoProgress)}%
        </div>

        <div
  className={cn(
    quizCompleted && "text-green-600",
    !quizCompleted && quizUnlocked && "text-green-600"
  )}
>
  <FileQuestion />
  {" "}
  Quiz: {
    quizCompleted
      ? `${quizScore}%`
      : quizUnlocked
      ? "Unlocked"
      : "Locked"
  }
</div>

        <div className={cn(passed && "text-green-600")}>
          <Award /> Certificate
        </div>

        {passed && onDownloadCertificate && (
          <Button
            size="sm"
            variant="outline"
            onClick={onDownloadCertificate}
          >
            <Download /> Download Certificate
          </Button>
        )}
      </div>
    </div>
  );
};

export default ModuleProgress;
